"use client";

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "@nextui-org/react";
import Link from "next/link";
import React from "react";
import { MdOutlineDesktopAccessDisabled } from "react-icons/md";

const AccessDeniedScreen = () => {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <Card className="max-w-[400px] p-3">
        <CardHeader className="flex flex-col gap-3 bg-zinc-800 rounded-xl p-5">
          <MdOutlineDesktopAccessDisabled size={60} />
          <div className="flex flex-col justify-center items-center w-full">
            <p className="text-md mb-0">خطا!</p>
            <p className="text-small text-default-500 mt-0">دسترسی نامعتبر</p>
          </div>
        </CardHeader>
        <CardBody>
          <p>صفحه مورد نظر با رده سنی انتخاب شده مطابقت ندارد</p>
        </CardBody>
        <CardFooter className="justify-center">
          <Link href="/">
            <Button
              color="primary"
              radius="full"
              fullWidth
              size="lg"
              className="text-primary-white flex-auto w-full text-lg"
            >
              بازگشت به صفحه اصلی
            </Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AccessDeniedScreen;
